module.exports = __webpack_public_path__ + "static/naideia-profile-pic-0b5593b135fd2347e132bc28527e8436.jpg";